export default "__VITE_ASSET__CoGr33Bw__"